/**
 * XML formatted, UTF-8 encoded, text header.
 *
 *
 * @beta
 */
export const TEXT_XML_UTF8 = 'text/xml; charset=utf-8'
